import { NotificationResource } from "models/Resources/NotificationResource";

export function isNotificationExpired(n: NotificationResource, now: number) {
  return Boolean(n.expiryDate && new Date(n.expiryDate).getTime() <= now);
}
